<template>
  <div class="filter-panel">
    <el-form :inline="true">
      <el-form-item :label="$t('dos.filter.transfer_request_type')">
        <el-select
            v-model="filters.transfer_request_type"
            :placeholder="$t('dos.filter.placeholder_type')"
            clearable
            style="width: 100%;">
          <el-option
              v-for="option in typeOptions"
              :key="option.value"
              :label="option.label"
              :value="option.value" />
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('dos.filter.mac_address')">
        <el-input
            v-model="filters.mac_address"
            :placeholder="$t('dos.filter.placeholder_mac')"
            maxlength="17" />
      </el-form-item>
      <el-form-item :label="$t('dos.filter.status')">
        <el-select
            v-model="filters.status"
            :placeholder="$t('dos.filter.placeholder_status')"
            clearable
            style="width: 100%;">
          <el-option
              v-for="option in statusOptions"
              :key="option.value"
              :label="option.label"
              :value="option.value" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button
            type="primary"
            @click="applyFilters">
          {{ $t('dos.filter.apply') }}
        </el-button>
        <el-button
            @click="clearFilters">
          {{ $t('dos.filter.clear') }}
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "FilterPanel",
  data() {
    return {
      filters: {
        transfer_request_type: "",
        mac_address: "",
        status: "",
      },
    };
  },
  computed: {
    typeOptions() {
      return [
        { label: this.$t("dos.filter.options.type_owner_change"), value: "owner_change" },
        { label: this.$t("dos.filter.options.type_device_swap"), value: "device_swap" },
      ];
    },
    statusOptions() {
      return [
        { label: this.$t("dos.filter.options.status_pending"), value: "pending" },
        { label: this.$t("dos.filter.options.status_completed"), value: "completed" },
        { label: this.$t("dos.filter.options.status_failed"), value: "failed" },
        { label: this.$t("dos.filter.options.status_cancelled"), value: "cancelled" },
      ];
    },
  },
  methods: {
    applyFilters() {
      const appliedFilters = {};
      if (this.filters.transfer_request_type) {
        appliedFilters.transfer_request_type = this.filters.transfer_request_type;
      }
      if (this.filters.mac_address) {
        appliedFilters.mac_address = this.filters.mac_address;
      }
      if (this.filters.status) {
        appliedFilters.status = this.filters.status;
      }
      this.$emit("filter-applied", appliedFilters);
    },
    clearFilters() {
      this.filters = {
        transfer_request_type: "",
        mac_address: "",
        status: "",
      };
      this.$emit("filter-cleared");
    },
  },
};
</script>

<style scoped>
.filter-panel {
  margin-bottom: 15px;
}
</style>
